import { Routes } from '@angular/router';

export const platformConfigRoute: Routes = [
  {
    path: 'configuration',
    // canActivate: [MenuGuard],
    loadChildren: () => import('./features/configuration/configuration.module').then(m => m.ConfigurationModule)
  }
];
